import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Container, Box, Typography } from '@mui/material';
import { DashboardLayout } from '@components/DashboardLayout.tsx';
import { AdaptiveTabs, AdaptiveTabItem, useAdaptiveTab } from '@components/common/AdaptiveTabs.tsx';
import { AdminMobileVersionSettings } from '@components/admin/AdminMobileVersionSettings.tsx';
import { PageIndices, TabIndices } from '@/common/i-doc/i-doc.registry';
import { PageHint } from '@components/common/PageHint.tsx';

const TABS: AdaptiveTabItem[] = [
  { value: 'general', label: 'Загальні', iDoc: TabIndices.ADMIN_SYSTEM_SETTINGS_GENERAL },
];

const AdminSystemSettingsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const tabParam = searchParams.get('tab');
  const currentTab = useAdaptiveTab(TABS, { searchParamKey: 'tab', defaultValue: 'general', storageKey: 'tab:admin-system-settings' });

  // Промпти - окрема сторінка (2026-09-30); старі посилання на вкладку ведуть туди.
  if (tabParam === 'prompts') return <Navigate to="/admin/system-prompts" replace />;

  return (
    <DashboardLayout onChangePassword={() => {}} data-i-doc={PageIndices.ADMIN_SYSTEM_SETTINGS}>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <PageHint iDoc={PageIndices.ADMIN_SYSTEM_SETTINGS} />
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Системні налаштування
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Керування глобальними параметрами платформи Everyday.
          </Typography>
        </Box>

        <AdaptiveTabs tabs={TABS} searchParamKey="tab" defaultValue="general" storageKey="tab:admin-system-settings" />

        <Box sx={{ pt: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
          {currentTab === 'general' && (
            <>
              <AdminMobileVersionSettings />
            </>
          )}
        </Box>
      </Container>
    </DashboardLayout>
  );
};

export default AdminSystemSettingsPage;
